import { BiCalendar, BiCar, BiPlus } from 'react-icons/bi';

import AddAppointmentDialog from '@features/appointments/components/AddAppointmentDialog';
import type { ProductActionsDefinition } from '@hopdrive/feature-portal-products';

import BuildRunDialog from './components/BuildRunDialog';

/**
 * Mobile Service's header actions: one "New" menu with the two ways to create work, each a dialog
 * the layout mounts at product level so it opens from every tab. No presence conditions; the
 * layout gates both on the entry's `canCreate`.
 */
const MOBILE_SERVICE_ACTIONS: ProductActionsDefinition = {
  menuLabel: 'New',
  menuIcon: <BiPlus />,
  createUnavailableText: 'Creating runs and appointments is unavailable for this rooftop',
  // Priority order: the landing tab's CTA first.
  creation: [
    {
      key: 'appointment',
      label: 'Appointment',
      icon: <BiCalendar />,
      dialog: ({ open, onClose, onCreated }) => (
        <AddAppointmentDialog open={open} onClose={onClose} onSuccess={onCreated} />
      ),
    },
    {
      key: 'run',
      label: 'Run',
      icon: <BiCar />,
      dialog: ({ open, onClose, onCreated }) => <BuildRunDialog open={open} onClose={onClose} onSuccess={onCreated} />,
    },
  ],
};

/** Mobile Service's actions take no facts; the definition is one shared object. */
export function resolveMobileServiceActions(): ProductActionsDefinition {
  return MOBILE_SERVICE_ACTIONS;
}
